<template>
    <div class="custom-tooltip-container">
        <span class="custom-tooltip-trigger">
            <slot name="triggerTooltip"></slot>
        </span>
        <div class="custom-tooltip flex-row">
            <slot name="contentTooltip" />
        </div>
    </div>
</template>

<script>
export default {
    name: 'CustomTooltip',
};
</script>

<style lang="scss">
@use '~@sellsy/styleguide/src/_variables' as *;

.custom-tooltip-container {
    display: inline-block;
    position: relative;
    white-space: initial;

    .custom-tooltip-trigger {
        display: inline-block;

        &:hover {
            + .custom-tooltip {
                display: flex;
            }
        }
    }

    .custom-tooltip {
        align-items: center;
        background-color: white;
        border-radius: 4px;
        bottom: calc(100% + 4px);
        box-shadow: 0 0 8px 0 #11111133;

        color: $gray-100;
        display: none;
        gap: 6px;
        padding: 8px;

        position: absolute;
        width: max-content;
        z-index: 1;
    }
}
</style>
